import { formatDateTimeWithSeconds } from '../../utils/DateTimeUtils';
import {
  FunctionField,
  NumberField, RaRecord, SimpleShowLayout,
  TextField,
  useRecordContext,
} from "react-admin";
import CustomReferenceField from "../Common/CustomReferenceField";
import CallButton from "../Common/CallButton/CallButton";
import { UserType } from "../../enums/common";
import JsonViewer from "../Common/JsonViewer";
import MultiDayChefitDateTimeTable from "./MultiDayChefitDateTimeTable";
import { Box } from "@mui/material";

const MultiDayChefitMetaShow = () => {
  const record = useRecordContext();
  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "25% 30% 45%" }}>
        <SimpleShowLayout>
          <FunctionField label="id" render={(record: RaRecord) => {
              return (
                <div>{record?.id}</div>
              )
          }} />
          <TextField source="status" />
          {record?.clientId && <FunctionField label="Source of booking" render={(record: RaRecord) => {
            if (record?.clientId === 2) {
              return (
                <div>CENTAURUS</div>
              )
            }
            else if (record?.clientId === 4) {
              return (
                <div>CUSTOMER APP</div>
              )
            }
            else if (record?.clientId === 9) {
              return (
                <div>WEBSITE</div>
              )
            }
          }} />}
          <TextField source="paymentStatus" />
          <CustomReferenceField
            label="Pack Order Id"
            listName={"Combo"}
            source={"comboOrderId"}
          />
          <TextField source="totalPrice" />
          <TextField source="totalVisits" />
        </SimpleShowLayout>
        <SimpleShowLayout>
          <CustomReferenceField
            label="House"
            listName={"Houses"}
            source={"houseId"}
          />
          <FunctionField
            label="Address"
            render={(record: {
              house: { address: any; cityName: any; localityName: any; areaName: any; };
            }) =>
              [record?.house?.address, record?.house?.localityName, record?.house?.areaName, record?.house?.cityName]?.filter((each) => each !== null).join(', ')
            }
          />
          <CustomReferenceField
            label="Allocator Id"
            listName={"AdminUsers"}
            source={"allocatorId"}
          />
          <TextField source="allocatorName" />
          <TextField source="allocatorEmail" />
          <TextField source="customerName" />
        </SimpleShowLayout>
        <SimpleShowLayout>
          <TextField source={"cancellationReason"} />
          <TextField source={"cancellationSubReason"} />
          {record?.house?.lat !== null && record?.house?.long !== null && (
            <div>
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${record?.house?.lat},${record?.house?.long}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Go to google maps
              </a>
            </div>
          )}
        </SimpleShowLayout>
        <SimpleShowLayout>
          <NumberField source="totalPeople" />
          <FunctionField
            label="Slot Size"
            render={(record: RaRecord) =>
              record?.slotSize != null
                ? `${record.slotSize} hr${record.slotSize !== 1 ? "s" : ""}`
                : "-"
            }
          />
          <FunctionField
            label="Time Based"
            render={(record: RaRecord) =>
              record?.isTimeBased != null
                ? record.isTimeBased ? "Yes" : "No"
                : "-"
            }
          />
          <FunctionField
            label="People Guideline"
            render={(record: RaRecord) => record?.peopleGuideline || "-"}
          />
          <FunctionField
            label="Dish Guideline"
            render={(record: RaRecord) => record?.dishGuideline || "-"}
          />
          <CustomReferenceField
            label="Area Id"
            listName={"Areas"}
            source={"areaId"}
          />
          <CustomReferenceField
            label="City Id"
            listName={"Cities"}
            source={"cityId"}
          />
          <CustomReferenceField
            label="Locality Id"
            listName={"Localities"}
            source={"localityId"}
          />
          <CustomReferenceField
            label="Cook"
            listName={"Cooks"}
            source={"cookId"}
          />
          <CustomReferenceField
            label="Cx Selected Cook"
            listName={"Cooks"}
            source={"cxSelectedCookId"}
          />
          <FunctionField
            emptyText="Not Available"
            label="Cook Name"
            render={(record: RaRecord) => {
              if (!record?.cook?.cookFullProfile?.firstName) return `Not Available`
              return `${record?.cook?.cookFullProfile?.firstName} ${record?.cook?.cookFullProfile?.lastName}`;
            }
            }
          />
          <CallButton
            heading={'Cook phone number'}
            toPhoneNumber={record?.cook?.mobile}
            userType={UserType.COOK}
            referenceId={Number(record?.id)}
            referenceModelName={"COUPON_ORDER"}
          />
          {/* <TextField label="Cook Phone Number" source="cook.mobile" /> */}
        </SimpleShowLayout>
        <SimpleShowLayout>
          <CallButton
            heading={'Customer phone number'}
            toPhoneNumber={record?.customerPhoneNumber}
            userType={UserType.CUSTOMER}
            referenceId={Number(record?.id)}
            referenceModelName={"COUPON_ORDER"}
          />
          {/* <TextField source="customerPhoneNumber" /> */}
          <TextField label="Cancelled By" source="cancelledBy" />
          <TextField label="Cancelled By Email" source="cancelledByEmail" />
          <FunctionField
            label="Updated At"
            render={(record: RaRecord) =>
              `${record?.updatedAt ? formatDateTimeWithSeconds(record?.updatedAt) : 'Not Available'}`
          }
          />
          <FunctionField
            label="Created At"
            render={(record: RaRecord) =>
              `${record?.createdAt ? formatDateTimeWithSeconds(record?.createdAt) : 'Not Available'}`
          }
          />
          <FunctionField
            label="Payment Status Updated At"
            render={(record: RaRecord) =>
              `${record?.paymentStatusLastUpdatedAt ? formatDateTimeWithSeconds(record?.paymentStatusLastUpdatedAt) : 'Not Available'}`
          }
          />
          <FunctionField
            label="Cancelled At"
            render={(record: RaRecord) =>
              record?.cancelledAt ? <div>{formatDateTimeWithSeconds(record?.cancelledAt)}</div> : <div>Not Available</div>
            }
          />
        </SimpleShowLayout>
        <SimpleShowLayout>
          <Box>Visit Dates</Box>
          <MultiDayChefitDateTimeTable visitDateTimeArray = {record?.dateTime}/>
        </SimpleShowLayout>
      </div>
      <JsonViewer data={record} />
    </>
  );
};

export default MultiDayChefitMetaShow;
